export const GET = 'GET'
export const POST = 'POST'
export const PUT = 'PUT'
export const PATCH = 'PATCH'
export const DELETE = 'DELETE'

export default {
  GET,
  PUT,
  POST,
  PATCH,
  DELETE,
}
